import { Directive, ElementRef, Input, AfterViewInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules';

@Directive({
  selector: '[appSwiper]',
  standalone: true
})
export class SwiperDirective implements AfterViewInit, OnDestroy {
  @Input() config?: SwiperOptions;

  public swiperInstance?: Swiper;

  constructor(
    private el: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngAfterViewInit(): void {
    if (!this.config || !isPlatformBrowser(this.platformId)) return;

    this.swiperInstance = new Swiper(this.el.nativeElement, {
      modules: [Navigation, Pagination, Autoplay, FreeMode],
      ...this.config,
    });
  }

  ngOnDestroy(): void {
    this.swiperInstance?.destroy(true, true);
  }
}
